/**
 * Phase 2.4 — Display label for a finding's domain badge.
 *
 * When a finding originates from the telecom infrastructure layer
 * (source_type === 'infrastructure_security') we render the full
 * "Telecommunications Infrastructure Security" label so executives can
 * filter / group by domain on the merged Findings list. All other
 * findings keep their canonical CSV domain label unchanged.
 */
export const TELECOM_INFRA_DOMAIN_LABEL =
  "Telecommunications Infrastructure Security";

export function displayDomainLabel(
  csvDomain: string | null | undefined,
  sourceType: string | null | undefined,
): string {
  if ((sourceType ?? "").toLowerCase() === "infrastructure_security") {
    return TELECOM_INFRA_DOMAIN_LABEL;
  }
  return (csvDomain ?? "").trim() || "Uncategorized";
}
